module.exports = __webpack_public_path__ + "static/media/luise-pandalchagi.22ef5479.jpg";